export function chartEditGuardianRelationship(stored: string | null | undefined): string {
  return stored || '';
}
